import {
  Flex,
  Text,
  useColorModeValue,
  Icon,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import {
  convertDateToFormattedString,
  formatCurrencyFloor,
} from "config/functions";
import {
  MdCancel,
  MdOutlineDoNotDisturbOnTotalSilence,
  MdAttachMoney,
  MdOutlineGroupAdd,
  MdAddShoppingCart,
  MdMobiledataOff,
} from "react-icons/md";

export default function TransactionMacae(props: { extrato: any }) {
  const { extrato } = props;

  const textColor = useColorModeValue("secondaryGray.900", "brand.200");
  const iconBoxBg = useColorModeValue("secondaryGray.300", "brand.200");
  const textRedBg = useColorModeValue("red.500", "brand.200");
  const textVerdeBg = useColorModeValue("green.500", "brand.200");
  const textBg = useColorModeValue("brand", "brand.200");

  function truncateText(text: string, maxLength: number = 55): string {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  function truncateTextEstabelecimento(
    text: string,
    maxLength: number = 35
  ): string {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  function textoMaior(text: string, maxLength: number = 55): string {
    if (!text) return "";
    return text.length > maxLength ? "MAIOR" : "";
  }

  const statusIcon = (status: any) => {
    switch (status) {
      case "DEBITO": // debito
        return (
          <Icon as={MdAddShoppingCart} color={"purple.400"} w="22px" h="22px" />
        );
      case "CREDITO": // credito
        return (
          <Icon as={MdAttachMoney} color={textVerdeBg} w="22px" h="22px" />
        );
      case "ESTORNO": // credito
        return (
          <Icon as={MdAttachMoney} color={textVerdeBg} w="22px" h="22px" />
        );
      default:
        return (
          <Icon
            as={MdOutlineDoNotDisturbOnTotalSilence}
            color={textRedBg}
            w="22px"
            h="22px"
          />
        );
    }
  };

  return (
    <Accordion allowMultiple w="100%">
      <AccordionItem key={extrato?.dataCompra} border="none">
        <AccordionButton
          _expanded={{ bg: "gray.100" }}
          w="100%"
          justifyContent="space-between"
          px={4}
          py={3}
          borderRadius="md"
          _hover={{ bg: "gray.50" }}
        >
          <Flex direction="row" align="center" w="100%">
            <IconBox
              h="42px"
              w="46px"
              bg={iconBoxBg}
              border="1px solid"
              borderColor={
                extrato?.idTipoMovimento !== 2 ? "purple.400" : textVerdeBg
              }
              boxShadow={`0 0 0 22px ${iconBoxBg}`}
              me={4}
              icon={statusIcon(
                extrato?.idTipoMovimento === 44
                  ? "ESTORNO"
                  : extrato?.idTipoMovimento !== 2
                  ? "DEBITO"
                  : "CREDITO"
              )}
            />
            {extrato?.idTipoMovimento === 1 && (
              <Flex direction="column" w="100%">
                <Flex direction="row" align="center">
                  <Text color={textColor} fontSize="sm" fontWeight="700">
                    Estabelecimento:
                  </Text>
                  <Text color={textColor} fontSize="sm" fontWeight="200" ml={2}>
                    {truncateTextEstabelecimento(extrato?.estabelecimento)}
                  </Text>
                </Flex>
                <Flex direction="row" align="center">
                  <Text color={textBg} fontSize="sm" fontWeight="700">
                    Data compra:
                  </Text>
                  <Text color={textBg} fontSize="sm" fontWeight="200" ml={2}>
                    {convertDateToFormattedString(extrato?.dataCompra)}
                  </Text>
                </Flex>
                <Flex direction="row" align="center">
                  <Text color={textBg} fontSize="sm" fontWeight="700">
                    Total:
                  </Text>
                  <Text color={"red"} fontSize="sm" fontWeight="700" ml={2}>
                    {formatCurrencyFloor(extrato?.valorTotal)}
                  </Text>
                </Flex>
              </Flex>
            )}

            {extrato?.idTipoMovimento === 2 ||
              (extrato?.idTipoMovimento === 23 && (
                <Flex direction="column" w="100%">
                  <Flex direction="row" align="center">
                    <Text color={"green.400"} fontSize="sm" fontWeight="700">
                      Crédito em conta
                    </Text>
                  </Flex>
                  <Flex direction="row" align="center">
                    <Text color={textBg} fontSize="sm" fontWeight="700">
                      Data crédito:
                    </Text>
                    <Text color={textBg} fontSize="sm" fontWeight="200" ml={2}>
                      {convertDateToFormattedString(extrato?.dataMovimento)}
                    </Text>
                  </Flex>
                  <Flex direction="row" align="center">
                    <Text color={textBg} fontSize="sm" fontWeight="700">
                      Total:
                    </Text>
                    <Text
                      color={"green.400"}
                      fontSize="sm"
                      fontWeight="700"
                      ml={2}
                    >
                      {formatCurrencyFloor(extrato?.valorTotal)}
                    </Text>
                  </Flex>
                </Flex>
              ))}

            {extrato?.idTipoMovimento === 44 && (
              <Flex direction="column" w="100%">
                <Flex direction="row" align="center">
                  <Text color={"green.400"} fontSize="sm" fontWeight="700">
                    Estorno em conta
                  </Text>
                </Flex>
                <Flex direction="row" align="center">
                  <Text color={textBg} fontSize="sm" fontWeight="700">
                    Data estorno:
                  </Text>
                  <Text color={textBg} fontSize="sm" fontWeight="200" ml={2}>
                    {convertDateToFormattedString(extrato?.dataMovimento)}
                  </Text>
                </Flex>
                <Flex direction="row" align="center">
                  <Text color={textBg} fontSize="sm" fontWeight="700">
                    Total:
                  </Text>
                  <Text
                    color={"green.400"}
                    fontSize="sm"
                    fontWeight="700"
                    ml={2}
                  >
                    {formatCurrencyFloor(extrato?.valorTotal)}
                  </Text>
                </Flex>
              </Flex>
            )}
          </Flex>
          {extrato?.idTipoMovimento === 1 && <AccordionIcon ml={4} />}
        </AccordionButton>

        <AccordionPanel pb={4} pt={2}>
          {extrato?.listaItens &&
            extrato?.listaItens.map((item: any, index: number) => (
              <Flex
                key={index}
                direction={
                  textoMaior(item.descricaoItem) === "MAIOR" ? "column" : "row"
                }
                w="100%"
                mb={1}
                px={2}
                bg={index % 2 === 0 ? "gray.100" : "gray.200"}
                borderRadius="md"
                py={1}
              >
                <Flex
                  w="100%"
                  direction="row"
                  justify="space-between"
                  align="center"
                >
                  <Text
                    fontSize="sm"
                    color={textColor}
                    fontStyle="italic"
                    wordBreak="break-word"
                  >
                    Qtd.: {item?.quantidade} -{" "}
                    <strong>{truncateText(item?.descricaoItem)}</strong>
                  </Text>

                  <Text
                    fontSize="sm"
                    fontWeight="600"
                    color="red"
                    textAlign="right"
                  >
                    {formatCurrencyFloor(item?.valorItem)}
                  </Text>
                </Flex>
              </Flex>
            ))}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
